import { CrmNotification } from '../api/Notification';

export const WHATSAPP_GREETING = 'Hi, thank you for contacting OTA Prime. How may we help you?';

export function getWhatsAppNotificationUrl(notification: CrmNotification): string | null {
  if (notification.type !== 'whatsapp_inbound') return null;
  const phone = String(notification.metadata?.fromPhone || '').replace(/\D/g, '');
  if (phone.length < 8 || phone.length > 15) return null;
  return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(WHATSAPP_GREETING)}`;
}
